// global/modals/modals.lib

function initModalEvents() {
    // cerrar modal
    $('[data-remodal-id] .modal-close').click(function() {
        $(this).closest('[data-remodal-id]').remodal().close();
        return false;
    });

    var modalContent = $('#videosettings');

    $('.thumb-video .owner-video-show-modal').click(function()
    {
        updateOwnerModalStatus($(this), modalContent);

        modalContent.remodal().open();

        return false;
    });
    
    // modal filter

    $('#show-modal-filter').click(function() {
        if ($(window).width() < 768) {
            $('#modal-filter').remodal().open();
        }
        return false;
    });

    // modal filter

    $('#show-modal-status-filter').click(function() {
        if ($(window).width() < 768) {
            $('#modal-status-filter').remodal().open();
        }
        return false;
    });
}

/**
 * Visualiza y oculta las acciones que pueden y no pueden
 * realizarse desde el modal en función del estado del
 * vídeo, como es el caso de marcar/desmarcar como
 * destacado.
 */
function updateOwnerModalStatus(modalBtn, modalContent)
{
    updateOwnerModalOptions(modalBtn, modalContent);
    updateOwnerModalLinks(modalBtn, modalContent)
}

function updateOwnerModalOptions(modalBtn, modalContent)
{
    // si el usuario es admin o si el vídeo es privado, no puede marcar/desmarcar destacados

    if(modalBtn.hasClass('admin'))
    {
        if(modalBtn.hasClass('banned-video'))
        {
            modalContent.find('#ban-video-anchor').hide();
            modalContent.find('#unban-video-anchor').show();
        }
        else
        {
            modalContent.find('#ban-video-anchor').show();
            modalContent.find('#unban-video-anchor').hide();
        }
    }
    else
    {
        modalContent.find('#ban-video-anchor').hide();
        modalContent.find('#unban-video-anchor').hide();
    }

    if(modalBtn.hasClass('admin') || modalBtn.hasClass('private'))
    {
        modalContent.find('#highlight-video-anchor').hide();
        modalContent.find('#unhighlight-video-anchor').hide();
    }
    else
    {
        if(modalBtn.hasClass('highlighted'))
        {
            modalContent.find('#highlight-video-anchor').hide();
            modalContent.find('#unhighlight-video-anchor').show();
        }
        else
        {
            modalContent.find('#unhighlight-video-anchor').hide();
            modalContent.find('#highlight-video-anchor').show();
        }
    }
}

function updateOwnerModalLinks(modalBtn, modalContent)
{
    modalContent.find('#edit-video-anchor').attr('href', modalBtn.attr('data-edit-video-url'));
    modalContent.find('#play-video-anchor').attr('href', modalBtn.attr('data-play-video-url'));

    modalContent.find('.ban-video-anchor').off('click');

    modalContent.find('.ban-video-anchor').on('click', function(ev)
    {
        ev.preventDefault();

        banVideo(modalContent, modalBtn);
    });

    modalContent.find('#highlight-video-anchor').off('click');

    modalContent.find('#highlight-video-anchor').on('click', function(ev)
    {
        ev.preventDefault();

        highlightVideo(modalContent, modalBtn.attr('data-highlight-url'));
    });

    modalContent.find('#unhighlight-video-anchor').off('click');

    modalContent.find('#unhighlight-video-anchor').on('click', function(ev)
    {
        ev.preventDefault();

        unhighlightVideo(modalContent, modalBtn.attr('data-unhighlight-url'));
    });
}

function banVideo(modalContent, modalBtn)
{
    var url = modalBtn.attr('data-ban-url');

    if(!modalBtn.hasClass('banned-video'))
    {
        var data = {ban: 1};
    }

    $.ajax(
    {
        url: url,
        method: 'post',
        data: data,
    }).done(function(data)
    {
        if((data.error == false) && (data.result == 'ok'))
        {
            if(modalBtn.hasClass('banned-video'))
            {
                // se actualizan las opciones del modal
                modalContent.find('#ban-video-anchor').show();
                modalContent.find('#unban-video-anchor').hide();
                // se actualiza el estado de los botones que muestran el modal dentro de los thumbs
                $('.thumb-video .owner-video-show-modal[data-ban-url="' + url + '"]').each(function()
                {
                    $(this).removeClass('banned-video').closest('.thumb-video').removeClass('banned-video');
                });
            }
            else
            {
                // se actualizan las opciones del modal
                modalContent.find('#ban-video-anchor').hide();
                modalContent.find('#unban-video-anchor').show();
                // se actualiza el estado de los botones que muestran el modal dentro de los thumbs
                $('.thumb-video .owner-video-show-modal[data-ban-url="' + url + '"]').each(function()
                {
                    $(this).addClass('banned-video').closest('.thumb-video').addClass('banned-video');
                });
            }
        }
        else
        {
            alertWeb(data.message, 'error');
        }
    })
    .fail(function()
    {
        
    });
}

function highlightVideo(modalContent, url)
{
    $.ajax(
    {
        url: url,
        method: 'post'
    }).done(function(data)
    {
        if((data.error == false) && (data.result == 'ok'))
        {
            // se actualizan las opciones del modal
            modalContent.find('#highlight-video-anchor').hide();
            modalContent.find('#unhighlight-video-anchor').show();
            // se actualiza el estado de los botones que muestran el modal dentro de los thumbs
            $('.thumb-video .owner-video-show-modal.highlighted').removeClass('highlighted');
            $('.thumb-video .owner-video-show-modal[data-highlight-url="' + url + '"]').addClass('highlighted');
        }
        else
        {
            alertWeb(data.message, 'error');
        }
    })
    .fail(function()
    {
        
    });
}

function unhighlightVideo(modalContent, url)
{
    $.ajax(
    {
        url: url,
        method: 'get'
    }).done(function(data)
    {
        if((data.error == false) && (data.result == 'ok'))
        {
            // se actualizan las opciones del modal
            modalContent.find('#highlight-video-anchor').show();
            modalContent.find('#unhighlight-video-anchor').hide();
            // se actualiza el estado de los botones que muestran el modal dentro de los thumbs
            $('.thumb-video .owner-video-show-modal.highlighted').removeClass('highlighted');
            $('.thumb-video .owner-video-show-modal[data-highlight-url="' + url + '"]').addClass('highlighted');
        }
        else
        {
            alertWeb(data.message, 'error');
        }
    })
    .fail(function()
    {
        
    });
}
